import { AcademicOfferScheduleContent } from '../parts/Schedules/AcademicOfferSchedule';
import { AcademicOfferScheduleLoader } from '../parts/Schedules/loaders/AcademicOfferScheduleLoader';

export function AcademicOfferScheduleStep() {
  return (
    <AcademicOfferScheduleLoader>
      <AcademicOfferScheduleContent />
    </AcademicOfferScheduleLoader>
  );
}
